<template>
  <div class="content1">
    <div class="query_con">
      <!-- <el-button class="add" @click="addType">新增</el-button> -->
      <el-button class="add" @click="editType">修改</el-button>
    </div>
    <div class="table_con">
      <el-table
        :data="tableData"
        border
        style="width: 70%"
        v-loading="tableLoading"
        :max-height="windowHeight"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" align="center">
        </el-table-column>
        <el-table-column
          type="index"
          label="序号"
          align="center"
          min-width="60"
        >
        </el-table-column>
        <el-table-column
          prop="name"
          label="公益活动类型"
          align="center"
          min-width="100"
        >
        </el-table-column>
        <el-table-column
          prop="type"
          label="是否上级审批"
          align="center"
          min-width="100"
        >
          <template slot-scope="{ row }">
            <div>
              {{ row.type == 1 ? "是" : row.type == 2 ? "否" : "" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="coefficient"
          label="时长系数"
          align="center"
          min-width="80"
        >
        </el-table-column>
        <el-table-column
          prop="updateName"
          label="更新人"
          align="center"
          min-width="80"
        >
        </el-table-column>
        <el-table-column
          prop="updateTime"
          label="更新时间"
          align="center"
          min-width="160"
        >
        </el-table-column>
      </el-table>
    </div>
    <div class="query_con">
      <el-button class="add" @click="addManage">新增</el-button>
      <el-popconfirm title="确定要删除选中的内容吗？" @confirm='delManage'>
        <el-button style="margin-left: 20px;" slot="reference" class="add">删除</el-button>
      </el-popconfirm>
    </div>
    <div class="table_con">
      <el-table
        :data="adminList"
        border
        style="width: 70%"
        v-loading="adminTableLoading"
        :max-height="windowHeight"
        @selection-change="adminHandleSelectionChange"
      >
        <el-table-column type="selection" width="55" align="center">
        </el-table-column>
        <el-table-column
          type="index"
          label="序号"
          align="center"
          min-width="60"
        >
        </el-table-column>
        <el-table-column
          prop="empNo"
          label="管理员工号"
          align="center"
          min-width="100"
        >
        </el-table-column>
        <el-table-column
          prop="empName"
          label="管理员姓名"
          align="center"
          min-width="100"
        >
        </el-table-column>
        <el-table-column
          prop="isPush"
          label="是否推送审核信息"
          align="center"
          min-width="100"
        >
          <template slot-scope="{ row }">
            <div>
              {{ row.isPush == 1 ? "推送" : "不推送" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="更新时间"
          align="center"
          min-width="160"
        >
        </el-table-column>
      </el-table>
    </div>
    <!-- <div class="pagination_con">
      <el-pagination
        @size-change="handleSizeChange1"
        @current-change="handleCurrentChange1"
        :current-page="pageData.page"
        :page-sizes="[20, 40, 60, 80, 100]"
        :page-size="pageData.pageSize"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
      >
      </el-pagination>
    </div> -->
    <el-dialog
      :title="`公益审批配置${title}`"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <div class="dialog_content">
        <el-form
          :model="form"
          label-width="120px"
          class="demo-form-inline"
          ref="ruleForm"
          :rules="rules"
        >
          <el-row style="flex-wrap: wrap" type="flex" :gutter="20">
            <el-col :span="24">
              <el-form-item label="公益活动类型" prop="name">
                <el-input
                  v-model="form.name"
                  placeholder="请输入公益活动类型"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="是否审批" prop="type">
                <el-select
                  v-model="form.type"
                  placeholder="请选择是否审批"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in optionsApproval"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="时长系数" prop="coefficient">
                <el-input-number
                  v-model="form.coefficient"
                  controls-position="right"
                  :precision="2"
                  :step="0.01"
                  :min="0"
                ></el-input-number>
                <!-- <div class="form_hint">献血量*献血时长系数=时长</div> -->
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button class="add" @click="confirmSubmit" :disabled="isBtnDisabled"
          >提交</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="新增管理员"
      :visible.sync="dialogVisibleAdmin"
      width="30%"
      :before-close="handleCloseAdmin"
    >
      <div class="dialog_content">
        <el-form
          :model="formAdmin"
          label-width="150px"
          class="demo-form-inline"
          ref="ruleFormAdmin"
          :rules="rulesAdmin"
        >
          <el-row style="flex-wrap: wrap" type="flex" :gutter="20">
            <el-col :span="24">
              <el-form-item label="管理员姓名" prop="name">
                <el-select
                  v-model="formAdmin.name"
                  placeholder="请输入管理员姓名"
                  clearable
                  filterable
                  remote
                  :remote-method="changeOption"
                  :loading="loadingSelect"
                  @change="handleChange"
                  ref="select"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.empid"
                    :label="item.orgname + '-' + item.name"
                    :value="item.empid"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="管理员工号" prop="empNo">
                <el-input
                  v-model="formAdmin.empNo"
                  placeholder="请输入管理员工号"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="是否推送审核信息" prop="isPush">
                <el-select
                  v-model="formAdmin.isPush"
                  placeholder="请选择是否推送审核信息"
                >
                  <el-option label="是" value="1"> </el-option>
                  <el-option label="否" value="2"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCloseAdmin">取 消</el-button>
        <el-button
          class="add"
          @click="confirmSubmitAdmin"
          :disabled="isBtnDisabled"
          >提交</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/apis/medal";
import apis from "@/apis/publicWelfare";
import moment from "moment";
export default {
  name: "badgeMaintain",

  data() {
    return {
      query: {
        name: "",
      },
      form: {},
      formAdmin: {
        name: "",
        empNo: "",
        isPush: "1",
      },
      pageData: {
        page: 1,
        pageSize: 20,
      },

      total: 0,
      multipleSelection: [],
      adminMultipleSelection: [],
      tableData: [],
      adminList: [],
      options: [],
      tableLoading: false,
      adminTableLoading: false,
      windowHeight: 350,
      dialogVisible: false,
      dialogVisibleAdmin: false,
      loadingSelect: false,
      isBtnDisabled: false,
      optionsApproval: [
        {
          value: 1,
          label: "是",
        },
        {
          value: 2,
          label: "否",
        },
      ],
      title: "新增",
      rules: {
        coefficient: [
          {
            required: true,
            trigger: "blur",
            validator: this.validatecoefficient,
          },
        ],
      },
      rulesAdmin: {
        name: [
          { required: true, message: "请输入管理员姓名", trigger: "blur" },
        ],
      },
    };
  },
  mounted() {
    this.upload = api.upload;
    this.imgUrl = api.imgUrl;
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    this.queryData();
    this.getManageList();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    // 新增管理员
    addManage() {
      this.dialogVisibleAdmin = true;
    },
    // 取消新增管理员弹框
    confirmSubmitAdmin() {
      this.$refs.ruleFormAdmin.validate((valid) => {
        if (valid) {
          const params = {
            adminNo: this.formAdmin.empNo, // 审核人工号
            empNo: this.$store.state.userInfo.username, // 创建人工号
            isPush: this.formAdmin.isPush, // 1推送 2不推送
          };
          this.isBtnDisabled = true;
          apis
            .adminAdd(params)
            .then((res) => {
              if (res.code == 200) {
                this.$message({
                  message: "新增成功",
                  type: "success",
                });
                this.isBtnDisabled = false;
                this.$refs.ruleFormAdmin.resetFields();
                this.dialogVisibleAdmin = false;
                this.getManageList();
              }
            })
            .catch(() => {
              this.isBtnDisabled = false;
            });
        } else {
          return false;
        }
      });
    },
    // 删除管理员
    delManage() {
      if (this.adminMultipleSelection.length > 0) {
        let ids = [];
        this.adminMultipleSelection.forEach((item) => {
          ids.push(item.id);
        });
        apis.adminDelete({ idList: ids }).then((res) => {
          if (res.code == 200) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getManageList()
          }
        });
      } else {
        this.$message({
          type: "error",
          message: "请选择一条数据",
        });
      }
    },
    // 获取管理员列表
    getManageList() {
      apis.adminList().then((res) => {
        console.log(res, "res");
        if (res.code == 200) {
          this.adminList = res.data;
          this.adminList.forEach((item) => {
            item.createTime = moment(item.createTime).format("YYYY-MM-DD");
          });
        }
      });
    },
    //改变管理员
    changeOption(value) {
      this.loadingSelect = true;
      api
        .quaGetEmployeeInfo({
          name: value,
        })
        .then((data) => {
          this.options = data.data;
          this.loadingSelect = false;
        });
    },
    // 选择管理员
    handleChange() {
      this.formAdmin.empNo = this.options[0].workcode;
    },
    handleResize() {
      // 使用 window.innerHeight 获取窗口的高度
      this.$nextTick(() => {
        // this.windowHeight = window.innerHeight - 660;
      });
    },
    //校验时长系数
    validatecoefficient(rule, value, callback) {
      if (!value && !(value >= 0)) {
        callback(new Error("请输入时长系数"));
      } else {
        if (!(value >= 0)) {
          callback(new Error("时长系数不能小于0"));
        } else {
          callback();
        }
      }
    },
    // 选择table
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 选择table
    adminHandleSelectionChange(val) {
      this.adminMultipleSelection = val;
    },
    // 分页
    handleSizeChange1(val) {
      this.pageData.pageSize = val;
      this.queryData();
    },
    // 当前页数
    handleCurrentChange1(val) {
      this.pageData.page = val;
      this.queryData();
    },

    // 查询 列表
    queryData() {
      const json = {
        ...this.pageData,
        ...this.query,
      };
      this.tableLoading = true;
      api
        .queryPubBenefitTypeListApi(json)
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data.map((item) => {
              item.updateTime = moment(item.updateTime).format(
                "YYYY-MM-DD HH:mm:ss"
              );
              return item;
            });
            this.total = res.data.total;
          }
          this.tableLoading = false;
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    //显示新增编辑弹框
    addType() {
      this.title = "新增";
      this.dialogVisible = true;
    },
    //显示编辑弹框
    editType() {
      if (this.multipleSelection.length == 1) {
        this.title = "编辑";
        this.form = {
          name: this.multipleSelection[0].name,
          type: this.multipleSelection[0].type,
          coefficient: this.multipleSelection[0].coefficient,
          id: this.multipleSelection[0].id,
        };
        this.dialogVisible = true;
      } else if (this.multipleSelection.length > 1) {
        return this.$message({
          message: "请选择一条内容进行编辑",
          type: "warning",
        });
      } else {
        return this.$message({
          message: "请选择需要编辑的内容",
          type: "warning",
        });
      }
    },
    //取消新增编辑弹框
    handleClose() {
      this.dialogVisible = false;
      this.$refs.ruleForm.resetFields();
    },
    //取消新增编辑弹框
    handleCloseAdmin() {
      this.dialogVisibleAdmin = false;
      this.$refs.ruleFormAdmin.resetFields();
    },
    // 确认新增 编辑
    confirmSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.title == "编辑") {
            this.form.id = this.multipleSelection[0].id;
            this.form.empNo = this.$store.state.userInfo.username;
          }
          this.isBtnDisabled = true;
          api
            .editPubBenefitTypeApi({ ...this.form })
            .then((res) => {
              if (res.code == 200) {
                this.$message({
                  message: this.title + "成功",
                  type: "success",
                });
                this.isBtnDisabled = false;
                this.$refs.ruleForm.resetFields();
                this.dialogVisible = false;
                this.queryData();
              }
            })
            .catch(() => {
              this.isBtnDisabled = false;
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.content1 {
  background-color: #f2fcf9;

  .query_con {
    // margin: 30px 40px 20px 40px;
    padding: 40px 0 40px 40px;
    // border: 1px solid #e5e5e5;
    border-radius: 5px;
    ::v-deep {
      .el-date-editor .el-range-separator {
        padding: 0 28px;
      }
    }
    .add {
      color: #fff;
      background-color: #23c0d8;
      border-color: #23c0d8;
    }
  }
  .operate {
    margin: 20px 40px;
    .add {
      color: #fff;
      background-color: #23c0d8;
    }
  }
  .table_con {
    background-color: #fff;
    border: 1px solid #e2e6e5;
    padding: 40px 20px;
    margin: 0 40px;
    border-radius: 5px;
  }
  .pagination_con {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-top: 30px;
    padding-right: 40px;
  }
  .dialog-footer {
    .add {
      color: #fff;
      background-color: #23c0d8;
    }
  }
  ::v-deep .hide .el-upload--picture-card {
    display: none;
  }
}
.form_hint {
  margin-top: 10px;
  font-size: 20px;
  color: #c9554b;
  line-height: 25px;
}
::v-deep {
  .el-input-number--mini {
    width: 100%;
  }
  .el-select {
    width: 100%;
  }
}
</style>
